import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-record-lined",
  "use": "rt-base-record-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-record-lined\"><defs><style type=\"text/css\"></style></defs><path d=\"M664 738.9c0 17.7 13.3 32.1 29.6 32.1h236.7c16.4 0 29.6-14.3 29.6-32.1 0-17.6-13.3-31.9-29.6-31.9H693.6c-16.3-0.1-29.6 14.3-29.6 31.9zM930.5 851h-473c-16.3 0-29.5 14.2-29.5 32 0 17.7 13.2 32 29.5 32h472.9c16.3 0 29.5-14.3 29.5-32 0.1-17.8-13.1-32-29.4-32zM666 341.7l61.7-88.2c10.1-14.5 6.6-34.4-7.9-44.6L539.7 82.8c-14.5-10.1-34.4-6.6-44.6 7.9L440 169.3l-36.7 52.4-282.6 403.6-47.8 68.2L64 930.4c-0.4 11.6 11.3 19.8 22 15.4l219.5-89.4 47.8-68.2L636 384.6l30-42.9zM264 804.3l-133.2 54.3 5.4-143.7 0.3-0.4L264.3 804l-0.3 0.3z m36.9-52.8L173.2 662l282.6-403.6 127.8 89.5-282.7 403.6zM492.5 206l36.7-52.4L657 243l-36.7 52.4L492.5 206z\" p-id=\"2480\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/record-lined.svg
// module id = 1739
// module chunks = 228